"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DisableUser_exports = {};
__export(DisableUser_exports, {
  default: () => DisableUser_default
});
module.exports = __toCommonJS(DisableUser_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.2656 9.66406C11.2161 9.66406 12.0299 9.32552 12.707 8.64844C13.3841 7.97135 13.7227 7.15755 13.7227 6.20703C13.7227 5.25651 13.3841 4.44271 12.707 3.76562C12.0299 3.08854 11.2161 2.75 10.2656 2.75C9.30208 2.75 8.48177 3.08854 7.80469 3.76562C7.1276 4.44271 6.78906 5.25651 6.78906 6.20703C6.78906 7.15755 7.1276 7.97135 7.80469 8.64844C8.48177 9.32552 9.30208 9.66406 10.2656 9.66406ZM10.2656 3.84375C10.9167 3.84375 11.4701 4.07812 11.9258 4.54688C12.3945 5.0026 12.6289 5.55599 12.6289 6.20703C12.6289 6.85807 12.3945 7.41797 11.9258 7.88672C11.4701 8.34245 10.9167 8.57031 10.2656 8.57031C9.61458 8.57031 9.05469 8.34245 8.58594 7.88672C8.11719 7.41797 7.88281 6.85807 7.88281 6.20703C7.88281 5.55599 8.11719 5.0026 8.58594 4.54688C9.05469 4.07812 9.61458 3.84375 10.2656 3.84375ZM11.2031 11.1484H7.78516C7.23828 11.1484 6.72396 11.2461 6.24219 11.4414C5.76042 11.6367 5.33724 11.9102 4.97266 12.2617C4.62109 12.6003 4.34766 12.9974 4.15234 13.4531C3.94401 13.9219 3.83984 14.4167 3.83984 14.9375V16.2461C3.83984 16.4023 3.89193 16.5326 3.99609 16.6367C4.10026 16.7409 4.23047 16.793 4.38672 16.793C4.52995 16.793 4.65365 16.7409 4.75781 16.6367C4.875 16.5326 4.93359 16.4023 4.93359 16.2461V14.9375C4.93359 14.1953 5.20703 13.5573 5.75391 13.0234C6.3138 12.4896 6.99089 12.2227 7.78516 12.2227H11.2031C11.3594 12.2227 11.4896 12.1706 11.5938 12.0664C11.6979 11.9622 11.75 11.8385 11.75 11.6953C11.75 11.5391 11.6979 11.4089 11.5938 11.3047C11.4896 11.2005 11.3594 11.1484 11.2031 11.1484ZM15.1875 10.8359C14.237 10.8359 13.4232 11.1745 12.7461 11.8516C12.069 12.5286 11.7305 13.3424 11.7305 14.293C11.7305 15.2435 12.069 16.0573 12.7461 16.7344C13.4232 17.4115 14.237 17.75 15.1875 17.75C16.138 17.75 16.9518 17.4115 17.6289 16.7344C18.306 16.0573 18.6445 15.2435 18.6445 14.293C18.6445 13.3424 18.306 12.5286 17.6289 11.8516C16.9518 11.1745 16.138 10.8359 15.1875 10.8359ZM15.1875 11.9297C15.3828 11.9297 15.5651 11.9557 15.7344 12.0078C15.9167 12.0469 16.0924 12.1055 16.2617 12.1836L13.2539 15.6602C13.1237 15.4648 13.0195 15.2565 12.9414 15.0352C12.8633 14.8008 12.8242 14.5534 12.8242 14.293C12.8242 13.6419 13.0521 13.0885 13.5078 12.6328C13.9766 12.1641 14.5365 11.9297 15.1875 11.9297ZM15.1875 16.6562C14.9922 16.6562 14.7969 16.6367 14.6016 16.5977C14.4193 16.5456 14.2435 16.474 14.0742 16.3828L17.082 12.8867C17.2383 13.082 17.3555 13.3034 17.4336 13.5508C17.5117 13.7852 17.5508 14.0326 17.5508 14.293C17.5508 14.944 17.3164 15.5039 16.8477 15.9727C16.3919 16.4284 15.8385 16.6562 15.1875 16.6562Z",
      fill: "currentColor"
    }
  )
);
const SvgDisableUser = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DisableUser_default = SvgDisableUser;
